import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import Form from '../../components/Forms/Form/Form';
import { withAppContext } from '../../contexts/AppContext';

import './ProfilePersonalDatas.css'; 

class ProfilePersonalDatas extends React.Component {
    
    state = {
      visible: false,
      fcm_token: ''
    };

    constructor(props) {
      super(props);
      
      this.appRef = this.props.appContext?.appRef || null;
      this.formRef = React.createRef();
    }

    hiddens = {
      count_address_P: 1,
      count_address_B: 1,
      id_B_1:'',
      id_P_1:'',
      delete_address_B:'',
      delete_address_P:'',
      new_address_B:'',
      new_address_P:''
    };


  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {

    if(params.result?.user_data){
      this.appRef.current.setState({user_data: params.result.user_data}); // beállítjuk a bejelntkezés utáni állapotot
    }
    
    this.toggle();
  }

  toggle() {
    const fcm_token = localStorage.getItem('fcm_token_ready') || ''; 

    this.setState({visible: !this.state.visible, fcm_token});
  }

  render() { 

    if (!this.state.visible) {
      return null;
    }

    const fcm_token = this.state.fcm_token;

    return <div className={`container floating_container page_account_settings`}>
      <div className='floating_container_header no_drop_shadow no_border'>
        <PageHeader isHistoryBack={false} no_close={true} callback={() => this.toggle()} title={i18n.t('accountSettingsPersonalDatasTitle')}></PageHeader>
      </div>
      <div className="floating_container_content">
        <div className="form_wrapper"> 
            {this.appRef.current.state.settings?.display_fcm_token ? 
              <div className='row'>
                <div className="field text ">
                  <label className="field_label" style={{marginBottom: "15px", display: "inline-block"}}>FCM token:</label>
                  <textarea type="text" rows="5" >{fcm_token}</textarea>
                </div>
                <hr></hr>
              </div>
            : ''}

            

            <Form 
              onSuccess={(params) => {this.on_submit_success(params)}} 
              ref={this.formRef} 
              hiddens={this.hiddens} 
              name="account_settings" 
              submit_text={i18n.t('accountSettingsPersonalDatasButton')} 
              others={{'form_parts': 'personal_datas_block'}}
              parent={this} />
        </div>
      </div>
    </div>;
  }

}


export default withAppContext(ProfilePersonalDatas);